import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultBillingProfile } from '../helpers/get-default-billing-profile';

interface UpdateFirstLastNameStateZipAndCountryFnPayload {
    firstName: string;
    lastName: string;
    state: string;
    zipCode: string;
    country: string;
}

export type UpdateFirstLastNameStateZipAndCountryFn = (
    payload: UpdateFirstLastNameStateZipAndCountryFnPayload,
) => Promise<void>;

export function initUpdateFirstLastNameStateZipAndCountryFn({
    dependencies,
}: DomainInitPayload): UpdateFirstLastNameStateZipAndCountryFn {
    const { clientSdk } = dependencies;
    return async ({
        firstName,
        lastName,
        state,
        zipCode,
        country,
    }: UpdateFirstLastNameStateZipAndCountryFnPayload) => {
        try {
            const billingProfileName = {
                firstAndLastName: {
                    firstName,
                    lastName,
                },
            };
            const serviceAddress = {
                state,
                zipCode,
                country: country.toUpperCase(),
            };

            let billingProfileId = '';

            try {
                const response = await getDefaultBillingProfile(dependencies);
                billingProfileId = response.id;
            } catch {
                // silently fail
            }

            billingProfileId
                ? await clientSdk.commerce.billing.updateBillingProfile(
                      billingProfileId,
                      {
                          billingProfileName,
                          serviceAddress,
                      },
                  )
                : await clientSdk.commerce.billing.createBillingProfile({
                      billingProfileName,
                      serviceAddress,
                  });
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
